import routerOptions0 from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}